<div class="view-field">
  <h4 *ngIf="field.label && field.label.trim()" class="p-d-inline">{{ field.label }}: </h4>
  <span>{{ keyValue }}</span>
  <i *ngIf="isMissing"
    [class]="icon + ' localization-key-status-icon localization-key-status-icon--' + severity"
    [pTooltip]="tooltip"
    tooltipPosition="top"
    role="button"
    tabindex="0"
    [attr.aria-label]="tooltip"
    (click)="goToClientStrings($event)"
    (keydown.enter)="goToClientStrings($event)"></i>
</div>
